import * as Sentry from "@sentry/react";
import type { ReactElement, ReactNode } from "react";

interface SentryErrorBoundaryProps {
  children: ReactNode;
  fallback?: ReactElement;
}

export function SentryErrorBoundary({
  children,
  fallback,
}: SentryErrorBoundaryProps) {
  return (
    <Sentry.ErrorBoundary fallback={fallback ?? <DefaultErrorFallback />}>
      {children}
    </Sentry.ErrorBoundary>
  );
}

function DefaultErrorFallback() {
  return (
    <div className="flex h-screen items-center justify-center">
      <div className="text-center">
        <h1 className="text-2xl font-bold text-slate-900 dark:text-white">
          Something went wrong
        </h1>
        <p className="mt-2 text-slate-500">
          The error has been reported. Please refresh the page.
        </p>
        <button
          onClick={() => window.location.reload()}
          className="mt-4 rounded-lg bg-primary-600 px-4 py-2 text-sm font-medium text-white hover:bg-primary-700"
        >
          Refresh
        </button>
      </div>
    </div>
  );
}
